import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_BEGIN,
  COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_SUCCESS,
  COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_FAILURE,
  COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function updateConstantOfCollection(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_BEGIN,
    });
    const { projectId, version, collectionUuid, constantUuid } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/constants/${collectionUuid}/collection/${constantUuid}`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_SUCCESS,
              data: res.data,
              collectionUuid: args.collectionUuid,
            });
            Mixpanel.track('Updated collection constant');
            toast.success('Updated Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to update collection constant');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Updation failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to update collection constant');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Updation Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateConstantOfCollectionError() {
  return {
    type: COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_BEGIN:
      return {
        ...state,
        updateConstantOfCollectionPending: true,
        updateConstantOfCollectionError: null,
      };

    case COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        updateConstantOfCollectionPending: false,
        updateConstantOfCollectionError: null,
        projectCollections,
        selectedCollection: action.data,
      };

    case COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_FAILURE:
      return {
        ...state,
        updateConstantOfCollectionPending: false,
        updateConstantOfCollectionError: action.data.error,
      };

    case COLLECTIONS_UPDATE_CONSTANT_OF_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        updateConstantOfCollectionError: null,
      };

    default:
      return state;
  }
}
